exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file-label:after{left:0;right:auto;border-left-width:0;border-right:inherit}", ""]);

// exports
